import classlist from "../../../../assets/images/docs/classlist.png";
import navigator from "../../../../assets/images/docs/navigator.png";
import flexgrid from "../../../../assets/images/blogs/pp131/flexgrid.png";
import debugpanel from "../../../../assets/images/blogs/pp14/debug.png";
import layertree from "../../../../assets/images/docs/layertree.png";
import containerquerystylepanel from "../../../../assets/images/docs/containerquerystylepanel.png";
import ShortCutDisplay from "../../../../src/components/ShortcutDisplay";
import * as React from 'react';
export default {
  classlist,
  navigator,
  flexgrid,
  debugpanel,
  layertree,
  containerquerystylepanel,
  ShortCutDisplay,
  React
};